import React from 'react';

interface GoogleFormEmbedProps {
  src: string;
  width?: string;
  height?: string;
  title: string;
}

export const GoogleFormEmbed: React.FC<GoogleFormEmbedProps> = ({
  src,
  width = 'auto',
  height = '500',
  title,
}) => {
  return (
    <div
      style={{
        margin: 'auto',
        width,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height={height}
        title={title}
        style={{ border: 'none', overflow: 'hidden' }}
        allowFullScreen
      >
        Loading...
      </iframe>
    </div>
  );
};
